import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'

const DEFAULT_CHAR_LIMIT = 20

const truncateToChars = (text, limit) => {
  const value = String(text).trim()
  if (value.length <= limit) return value
  return `${value.slice(0, limit)}…`
}

export default function ExpandableReasonText({
  text,
  isMobile = false,
  modalTitle = 'Leave Details',
  modalDetails = [],
  charLimit = DEFAULT_CHAR_LIMIT,
  contentLabel = 'Reason',
}) {
  const [showModal, setShowModal] = useState(false)
  const displayText = text && text !== '—' ? String(text).trim() : '—'

  if (displayText === '—' || !displayText) {
    return <span className="text-muted">—</span>
  }

  const isLong = displayText.length > charLimit
  const previewText = isLong ? truncateToChars(displayText, charLimit) : displayText

  const textStyle = {
    fontSize: isMobile ? '14px' : '13px',
    lineHeight: 1.5,
    color: '#111827',
    wordBreak: 'break-word',
    fontFamily: 'Inter, system-ui, sans-serif',
  }

  const showButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginLeft: isLong ? '8px' : 0,
    padding: isMobile ? '6px 12px' : '4px 10px',
    minHeight: isMobile ? '32px' : '28px',
    borderRadius: '6px',
    border: '1px solid #223843',
    backgroundColor: '#ffffff',
    color: '#223843',
    fontSize: isMobile ? '12px' : '11px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'Inter, system-ui, sans-serif',
    whiteSpace: 'nowrap',
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: isMobile ? 'flex-start' : 'center',
          flexWrap: isMobile ? 'wrap' : 'nowrap',
          gap: isMobile ? '6px' : 0,
          maxWidth: '100%',
        }}
      >
        <span style={textStyle}>{previewText}</span>
        {isLong && (
          <button
            type="button"
            onClick={() => setShowModal(true)}
            style={showButtonStyle}
          >
            Show
          </button>
        )}
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size={isMobile ? undefined : 'lg'}
        scrollable
      >
        <Modal.Header closeButton style={{ borderBottom: '1px solid #E5E7EB' }}>
          <Modal.Title
            style={{
              fontFamily: 'Inter, system-ui, sans-serif',
              fontSize: isMobile ? '18px' : '20px',
              fontWeight: 700,
              color: '#223843',
            }}
          >
            {modalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: 'Inter, system-ui, sans-serif',
            padding: isMobile ? '16px' : '24px',
          }}
        >
          {modalDetails.length > 0 && (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : '140px 1fr',
                gap: isMobile ? '12px' : '16px 20px',
                marginBottom: '20px',
              }}
            >
              {modalDetails.map(({ label, value }) => (
                <React.Fragment key={label}>
                  <div
                    style={{
                      fontSize: '13px',
                      fontWeight: 600,
                      color: '#6B7280',
                    }}
                  >
                    {label}
                  </div>
                  <div
                    style={{
                      fontSize: '14px',
                      color: '#111827',
                      wordBreak: 'break-word',
                    }}
                  >
                    {value ?? '—'}
                  </div>
                </React.Fragment>
              ))}
            </div>
          )}

          <div>
            <div
              style={{
                fontSize: '13px',
                fontWeight: 600,
                color: '#6B7280',
                marginBottom: '8px',
              }}
            >
              {contentLabel}
            </div>
            <div
              style={{
                fontSize: '14px',
                lineHeight: 1.6,
                color: '#111827',
                wordBreak: 'break-word',
                overflowWrap: 'anywhere',
                whiteSpace: 'pre-wrap',
                backgroundColor: '#F9FAFB',
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                padding: isMobile ? '12px' : '16px',
              }}
            >
              {displayText}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: '1px solid #E5E7EB' }}>
          <button
            type="button"
            onClick={() => setShowModal(false)}
            style={{
              borderRadius: '8px',
              padding: isMobile ? '10px 20px' : '8px 18px',
              border: 'none',
              backgroundColor: '#223843',
              color: '#ffffff',
              fontSize: '13px',
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: 'Inter, system-ui, sans-serif',
              width: isMobile ? '100%' : 'auto',
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
